/* Product-page offer bar refresh (snippets/oparina-offer-bar.liquid). After a cart change (PUB_SUB_EVENTS.cartUpdate) or a
   variant change (PUB_SUB_EVENTS.variantChange) Shopify re-renders only the bar (Section Rendering API, read-only GET of
   sections/oparina-offer-bar.liquid on this product URL, keeping the selected ?variant=) and it is swapped in place.
   A newer request aborts the previous one, and the bar is looked up again when the answer arrives, so quick +/- taps
   never leave a stale bar. No cart writes; on any error the current bar simply stays. */
(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  let pending = null;
  const refresh = (variantId) => {
    if (!document.querySelector('[data-oparina-offer-section] [data-oparina-offer]')) return;
    const params = new URLSearchParams(window.location.search);
    if (variantId) params.set('variant', variantId);
    params.set('section_id', 'oparina-offer-bar');
    if (pending) pending.abort();
    pending = new AbortController();
    fetch(`${window.location.pathname}?${params}`, { headers: { Accept: 'text/html' }, signal: pending.signal })
      .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
      .then((html) => {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-oparina-offer]');
        const bar = document.querySelector('[data-oparina-offer-section] [data-oparina-offer]');
        if (fresh && bar) bar.replaceWith(fresh);
      })
      .catch(() => {});
  };
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => refresh());
  if (PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, (e) => refresh(e && e.data && e.data.variant && e.data.variant.id));
  }
})();
